let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("htes7")).then(() => parcelRequire('6P7Pf'));